import axios from 'axios';

const AZURE_CONFIG = {
    accountName: "zentechinfo",
    containerName: "hello-digital-transformation",
    sasToken: "sp=racw&st=2026-04-07T08:14:36Z&se=2030-04-07T16:29:36Z&spr=https&sv=2024-11-04&sr=c&sig=0Ns5CPs6CTDFXN%2Fd91KNsb08bQaLQ0ytrjzyUiZmfc0%3D", // Generate this in Azure Portal

};

/**
 * Upload file to Azure Blob
 * @param {File} file
 */
export const uploadImageToAzure = async (file) => {
    try {
        const folderName = "your_folder_name";
        const fileName = `${Date.now()}-${file.name}`;
        const blobPath = `${folderName}/${fileName}`;
        const contentType = file.type || 'application/octet-stream';

        // Ensure SAS starts with ?
        const cleanSas = AZURE_CONFIG.sasToken.startsWith('?')
            ? AZURE_CONFIG.sasToken
            : `?${AZURE_CONFIG.sasToken}`;

        // Construct URL
        const baseUrl = `https://${AZURE_CONFIG.accountName}.blob.core.windows.net`;
        const uploadUrl = `${baseUrl}/${AZURE_CONFIG.containerName}/${blobPath}${cleanSas}`;


        const response = await axios.put(uploadUrl, file, {
            headers: {
                'x-ms-blob-type': 'BlockBlob',
                'Content-Type': contentType,
            },
        });

        if (response.status === 201) {
            const finalUrl = `${baseUrl}/${AZURE_CONFIG.containerName}/${blobPath}`;


            return finalUrl;
        }

        return null;

    } catch (error) {
        if (error.response) {
            console.error("❌ AZURE ERROR:", error.response.status, error.response.data);
        } else {
            console.error("❌ CONNECTION ERROR:", error.message);
        }
        return null;
    }
};